"use client";

import type { CSSProperties } from "react";

function SkeletonBar({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rounded bg-contrast/6 shimmer shimmer-bg text-foreground ${className}`}
      style={style}
    />
  );
}

export function AboutSkeleton() {
  return (
    <div className="flex flex-col">
      <SkeletonBar className="h-[52px] w-full !rounded-t-md !rounded-b-none" />
      <div className="flex flex-col gap-2 rounded-b-md border border-border bg-surface-elevated p-5">
        <SkeletonBar className="h-3.5 w-full" />
        <SkeletonBar className="h-3.5 w-full" />
        <SkeletonBar className="h-3.5 w-[75%]" />
      </div>
    </div>
  );
}
